import { api } from './index';
import type { Quotation, QuotationItem } from './rfq';

export interface CreateQuotationDto {
  validityDays: number;
  deliveryDays: number;
  paymentTerms?: string;
  notes?: string;
  items: Omit<QuotationItem, 'id' | 'rfqItem'>[];
}

export const quotationsApi = {
  create: (rfqId: string, data: CreateQuotationDto): Promise<Quotation> =>
    api.post(`/rfq/${rfqId}/quotations`, data, { useVendorAuth: true }).then((res) => res.data),

  update: (rfqId: string, id: string, data: Partial<CreateQuotationDto>): Promise<Quotation> =>
    api.patch(`/rfq/${rfqId}/quotations/${id}`, data, { useVendorAuth: true }).then((res) => res.data),

  submit: (rfqId: string, id: string): Promise<Quotation> =>
    api.post(`/rfq/${rfqId}/quotations/${id}/submit`, undefined, { useVendorAuth: true }).then((res) => res.data),

  get: (rfqId: string, id: string): Promise<Quotation> =>
    api.get(`/rfq/${rfqId}/quotations/${id}`).then((res) => res.data),

  list: (rfqId: string): Promise<Quotation[]> =>
    api.get(`/rfq/${rfqId}/quotations`, { useVendorAuth: true }).then((res) => res.data),

  validate: (rfqId: string, id: string): Promise<{ isComplete: boolean; reasons: string[] }> =>
    api.get(`/rfq/${rfqId}/quotations/${id}/validate`, { useVendorAuth: true }).then((res) => res.data),

  // Document operations
  uploadDocument: (quotationId: string, file: File, documentType?: string): Promise<any> => {
    const formData = new FormData();
    formData.append('file', file);
    if (documentType) {
      formData.append('documentType', documentType);
    }
    return api.post(`/rfq/quotations/${quotationId}/documents`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      useVendorAuth: true,
    }).then((res) => res.data);
  },

  listDocuments: (quotationId: string): Promise<any[]> =>
    api.get(`/rfq/quotations/${quotationId}/documents`, { useVendorAuth: true }).then((res) => res.data),

  deleteDocument: (quotationId: string, documentId: string): Promise<void> =>
    api.delete(`/rfq/quotations/${quotationId}/documents/${documentId}`, { useVendorAuth: true }).then(() => undefined),
};

